import React, { useEffect, useState } from "react"
import MgmtLayout from "../../../components/layouts/MgmtLayout";
import { Card, Form, Col, Input, Row, Select, DatePicker } from "antd";
import AuthContext from "../../../main/authenticationProvider";
import MgmtService from "../../../app/service/mgmtService";
import { Button } from "../../../components/button";
import { messageError, messageSuccess } from "../../../components/toastr";


export const SettingHorimeter = () => {
    const mgmtService = new MgmtService();
    const auth = new AuthContext();

    const [plates, setPlates] = useState([]);
    const [clients, setClients] = useState([]);
    const [loadingDate, setLoadingDate] = useState(false);


    useEffect(() => {
        getClients();
    }, [clients]);


    const getClients = () => {

        mgmtService.getClients()
            .then((response) => {
                let opt = [];
                response.data.data.forEach((item, index) => {
                    opt.push({
                        key: index,
                        value: item.apiUsername,
                        label: item.apiUsername,
                    });
                });
                setClients(opt);
            }).catch((erro) => {
                erro && erro.response && auth.verifyAuth();
            });
    }
    const getPlatesByClient = (client) => {

        const data = {
            "client": client,
        }
        mgmtService.getPlatesByClient(data)
            .then((response) => {
                let opt = [];
                response.data.data.forEach((item, index) => {
                    opt.push({
                        key: index,
                        value: item.plate,
                        label: item.plate,
                    });
                });
                setPlates(opt);

            }).catch((erro) => {
                erro && erro.response && auth.verifyAuth();
            });
    }


    const saveSetting = (data) => {
        const formattedDate = data.setting_horimeter ? data.setting_horimeter.format("YYYY-MM-DD HH:mm:ss") : null;

        const filter = {
            "plate": data.plate,
            "value": data.input_value,
            "dateUpdate": formattedDate,
        }
        mgmtService.updateHorimeter(filter).then((response) => {
            if (response.data.status === 200) {
                messageSuccess("Valor atualizado com sucesso!")
            }

        }).catch((error) => {
            if (error.response.status === 401) {
                error && error.response && auth.verifyAuth();
            } else if (error.response.status === 404) {
                messageError("ERRO! " + error.response.data.message)
            }
            //
        })
    }

    return (
        <MgmtLayout>
            <Card title='Configurar Horímetro'>
                <Form onFinish={(data) => saveSetting(data)} layout="vertical">
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Selecione um Cliente</b>} name="client">
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    onChange={(client) => {
                                        getPlatesByClient(client);
                                    }}
                                    placeholder="Clientes"
                                    allowClear
                                    options={clients ? clients : null}
                                    style={{ width: '85%' }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Selecione a Placa</b>} name="plate">
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    onChange={(plate) => {
                                    }}
                                    placeholder="Placas"
                                    allowClear
                                    options={plates ? plates : null}
                                    style={{ width: '85%' }}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Data da Configuração</b>} name="setting_horimeter">
                                <DatePicker
                                    format={{
                                        format: 'DD-MM-YYYY HH:mm:ss',
                                        type: 'mask',
                                    }}
                                    size={'middle'}
                                    placeholder='Data Configuração'
                                    style={{ width: '90%' }}

                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Valor configurado (em Minutos)</b>} name="input_value">
                                <Input
                                    type="number"
                                    placeholder='Valor Configurado em Minutos'
                                    onKeyDown={(event) => {
                                        if (event.key === '.' || event.key === ',' || event.key === 'e' || event.key === '-' || event.key === '+') {
                                            event.preventDefault();
                                        }
                                    }}
                                    name='input_value' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col style={{ display: 'flex', justifyContent: 'end' }} span={24}>
                            <Button htmlType='submit' loading={loadingDate} className='defaultButton'>Salvar</Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </MgmtLayout>
    );
}